<template>
  <div class="lunbo" :class="name" :style="{ height: h + 'px' }">
    <div class="left" @click="turnLeft"></div>
    <div class="right" @click="turnRight"></div>
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div
          @click="getDetail(item)"
          class="swiper-slide"
          :class="{ 'is-active': item.auditName == auditName }"
          v-for="(item, index) in banners"
          :key="index"
        >
          <span>{{ item.auditName }}</span>
          <span>管理员：{{ item.createMemberName }}</span>
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
  </div>
</template>

<script>
import 'swiper/swiper-bundle.css';
import Swiper from 'swiper/swiper-bundle.js';
export default {
  props: ['banners', 'name', 'h'],
  data() {
    return {
      mySwipe: null,
      auditName: '',
    };
  },
  watch: {},
  methods: {
    getBigImg(url) {
      this.$emit('getUrl', url);
    },
    turnLeft() {
      // this.mySwipe.swipePrev()
    },
    turnRight() {
      // this.mySwipe.swipeNext()
    },
    getDetail(item) {
      this.auditName = item.auditName;
      this.$emit('getItemId', item.auditId);
    },
  },
  mounted: function() {
    let vm = this;
    // eslint-disable-next-line no-new
    this.mySwipe = new Swiper('.' + vm.name + ' .swiper-container', {
      navigation: {
        nextEl: '.right',
        prevEl: '.left',
      },
      slidesPerView: 5,
    });
  },
};
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
/*没有分页器 加scoped不会错  */
a {
  cursor: pointer;
}
.lunbo {
  margin: 0 auto;
  position: relative;
}
.swiper-container {
  height: 100%;
  ::v-deep .swiper-wrapper {
    .is-active {
      background-color: #fff;
      border-bottom: none;
      span:first-child {
        color: #0064c8;
      }
    }
    // display: flex;
    // justify-content: space-around;
    // transform:translate3d(-60px, 0px, 0px)
  }
}

.swiper-slide {
  height: 100%;
  width: 152px !important;
  color: white;
  // margin-right: 14px;
  display: flex;
  flex-flow: column;
  background-color: #f8f8f8;
  align-items: center;
  justify-content: center;
  border: 1px solid #d9d9d9;
  // border-left: 1px solid #D9D9D9;
  cursor: pointer;
  img {
    width: 60px;
    height: 60px;
    border: 1px solid #d2d2d2;
  }

  span {
    display: block;
    line-height: 1;
    &:first-child {
      color: #333;
      font-size: 14px;
      margin-bottom: 10px;
    }
    &:last-child {
      color: #999;
      font-size: 12px;
    }
  }
  &:active {
    background-color: #fff;
    color: #0064c8;
  }
}
.swiper-pagination {
  position: absolute;
  z-index: 20;
  bottom: 10px;
  width: 100%;
  text-align: center;
}
/*分页器的样式*/
.swiper-pagination-switch {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 8px;
  background: #6d6df8;
  margin: 0 5px;
  opacity: 0.8;
  border: 1px solid #fff;
  cursor: pointer;
}
.swiper-active-switch {
  background: #fff;
}
.left {
  border: 1px solid #d2d2d2;
  width: 20px;
  height: 60px;
  background: url('../../../../../assets/img/enquiry/left-white.png') center center no-repeat
    #f8f8f8;
  background-size: 8px 14px;
  float: left;
  cursor: pointer;
  &:hover {
    background: url('../../../../../assets/img/enquiry/left-blue.png') center center no-repeat
      #eeeeee;
    background-size: 8px 14px;
  }
  // margin-top: 8px;
  // margin-right: 10px;
}
.right {
  border: 1px solid #d2d2d2;
  width: 20px;
  height: 60px;
  background: url('../../../../../assets/img/enquiry/right-whirt.png') center center no-repeat
    #f8f8f8;
  background-size: 8px 14px;
  float: right;
  cursor: pointer;
  &:hover {
    background: url('../../../../../assets/img/enquiry/right-blue.png') center center no-repeat
      #eeeeee;
    background-size: 8px 14px;
  }
  // margin-top: 8px;
}
</style>
